module.exports = __webpack_public_path__ + "static/img/9.ab32041.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/eng/9.png
// module id = hZ1U
// module chunks = 0